/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamAgentControlStateResponseConductPhase } from './oralExamAgentControlStateResponseConductPhase';
import type { OralExamAgentControlStateResponseExaminerReadyAt } from './oralExamAgentControlStateResponseExaminerReadyAt';
import type { OralExamAgentControlStateResponseStudentReadyAt } from './oralExamAgentControlStateResponseStudentReadyAt';
import type { OralExamAgentControlStateResponseCurrentQuestionId } from './oralExamAgentControlStateResponseCurrentQuestionId';
import type { OralExamAgentControlStateResponseStudentDoneAt } from './oralExamAgentControlStateResponseStudentDoneAt';
import type { OralExamAgentControlStateResponseStageGate } from './oralExamAgentControlStateResponseStageGate';
import type { OralExamAgentControlStateResponseEventsWritableReason } from './oralExamAgentControlStateResponseEventsWritableReason';
import type { OralExamAgentControlStateResponseQuestionDeadline } from './oralExamAgentControlStateResponseQuestionDeadline';
import type { OralExamAgentControlStateResponseAnswerStartedAt } from './oralExamAgentControlStateResponseAnswerStartedAt';
import type { OralExamAgentControlStateResponsePresentedAt } from './oralExamAgentControlStateResponsePresentedAt';
import type { OralExamAgentControlStateResponseRunState } from './oralExamAgentControlStateResponseRunState';
import type { OralExamAgentControlStateResponseEndReason } from './oralExamAgentControlStateResponseEndReason';
import type { OralExamAgentControlStateResponseQuestionIndex } from './oralExamAgentControlStateResponseQuestionIndex';
import type { OralExamAgentControlStateResponseQuestionTotal } from './oralExamAgentControlStateResponseQuestionTotal';
import type { OralExamAgentControlStateResponsePauseReason } from './oralExamAgentControlStateResponsePauseReason';
import type { OralExamAgentControlStateResponseOperationalFault } from './oralExamAgentControlStateResponseOperationalFault';

/**
 * Minimal machine-authenticated control read for the Nexus examiner handshake.
 */
export interface OralExamAgentControlStateResponse {
  conductPhase?: OralExamAgentControlStateResponseConductPhase;
  examinerReadyAt?: OralExamAgentControlStateResponseExaminerReadyAt;
  studentReadyAt?: OralExamAgentControlStateResponseStudentReadyAt;
  currentQuestionId?: OralExamAgentControlStateResponseCurrentQuestionId;
  committed?: boolean;
  studentDoneAt?: OralExamAgentControlStateResponseStudentDoneAt;
  stageGate?: OralExamAgentControlStateResponseStageGate;
  eventsWritable?: boolean;
  eventsWritableReason?: OralExamAgentControlStateResponseEventsWritableReason;
  isPaused?: boolean;
  questionDeadline?: OralExamAgentControlStateResponseQuestionDeadline;
  answerStartedAt?: OralExamAgentControlStateResponseAnswerStartedAt;
  presentedAt?: OralExamAgentControlStateResponsePresentedAt;
  runState?: OralExamAgentControlStateResponseRunState;
  endReason?: OralExamAgentControlStateResponseEndReason;
  currentQuestionText?: string;
  questionIndex?: OralExamAgentControlStateResponseQuestionIndex;
  questionTotal?: OralExamAgentControlStateResponseQuestionTotal;
  dispatchGeneration?: number;
  pauseReason?: OralExamAgentControlStateResponsePauseReason;
  operationalFault?: OralExamAgentControlStateResponseOperationalFault;
}
